//Protocol Disposition Type
export const Protocol_DispositionType_Admit = 'admit';
export const Protocol_DispositionType_Discharge = 'discharge';
const Protocol_DispositionTypes = [Protocol_DispositionType_Admit, Protocol_DispositionType_Discharge];
//Protocol Status
export const ProtocolStatus_AwaitingTests = 'awaiting-tests';
export const ProtocolStatus_AwaitingInfo = 'awaiting-info';
export const ProtocolStatus_AwaitingDispo = 'awaiting-dispo';
export const ProtocolStatus_Done = 'done';
export const ProtocolState_Completed = 'completed';
const ProtocolStatuses = [ProtocolStatus_AwaitingTests,
    ProtocolStatus_AwaitingInfo,
    ProtocolStatus_AwaitingDispo,
    ProtocolStatus_Done,
    ProtocolState_Completed];
//# sourceMappingURL=types.js.map